import { render, staticRenderFns } from "./TMenuSection.vue?vue&type=template&id=3d96b6aa&scoped=true&"
import script from "./TMenuSection.vue?vue&type=script&lang=ts&"
export * from "./TMenuSection.vue?vue&type=script&lang=ts&"
import style0 from "./TMenuSection.vue?vue&type=style&index=0&id=3d96b6aa&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d96b6aa",
  null
  
)

export default component.exports